import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { Useraction } from './useractions.interface';

@Injectable({
  providedIn: 'root',
})
/**
 * Groups REST calls
 */
export class UseractionService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);

  /**
   * Get all useractions
   */
  getActions(): Observable<Useraction[]> {
    const url = `${this.globals.apiRoot}/useractions`;
    return this.http.get<Useraction[]>(url);
  }

  /**
   *
   * @param id
   * @returns all useractions based on time
   */
  getActionsBasedOnTime(): Observable<Useraction[]> {
    const url = `${this.globals.apiRoot}/useractionsbasedontime`;
    return this.http.get<Useraction[]>(url);
  }

  /**
   *
   * @param id
   * @returns all useractions based on time
   */
  getActionsBasedOnTimeByInstallationId(
    installationId: number,
    isShared: boolean,
  ): Observable<Useraction[]> {
    const url = `${this.globals.apiRoot}/useractionsbasedontime/installation/${installationId}?isShared=${isShared}`;
    return this.http.get<Useraction[]>(url);
  }

  /**
   * Get useraction by id
   * @param id useraction id
   */
  getAction(id: number): Observable<Useraction> {
    const url = `${this.globals.apiRoot}/useractions/${id}`;
    return this.http.get<Useraction>(url);
  }

  getTimeAction(id: number): Observable<Useraction> {
    const url = `${this.globals.apiRoot}/JwtUserActions/v2/time/${id}`;
    return this.http.get<Useraction>(url);
  }

  updateActive(useraction: Useraction): Observable<void> {
    const url = `${this.globals.apiRoot}/useractions/${useraction.ID}/updateActive`;
    return this.http.post<void>(url, useraction);
  }

  /**
   * Update a useraction
   * @param useraction the useraction to update
   */
  updateUseraction(useraction: Useraction): Observable<void> {
    const url = `${this.globals.apiRoot}/useractions/${useraction.ID}`;
    return this.http.put<void>(url, useraction);
  }

  /**
   * Add a new useraction
   */
  addUseraction(useraction: Useraction): Observable<Useraction> {
    const url = `${this.globals.apiRoot}/useractions/add`;
    return this.http.post<Useraction>(url, useraction);
  }

  /**
   * Delete a useraction
   */
  deleteUseraction(id: number): Observable<void> {
    const url = `${this.globals.apiRoot}/useractions/delete/${id}`;
    return this.http.delete<void>(url);
  }

  /**
   * Test a useraction
   */
  testUseraction(id: number): Observable<void> {
    const url = `${this.globals.apiRoot}/useractions/test/${id}`;
    return this.http.get<void>(url);
  }
}
